import React from 'react';
import { Button } from './ui/Button';
import { ArrowRight } from 'lucide-react';
export function Hero() {
  return <section className="relative w-full overflow-hidden bg-wh-teal border-b-4 border-wh-yellow" data-id="element-180">
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-181">
        {/* Mascot Image - positioned within container, flush with bottom */}
        <div className="hidden lg:block absolute bottom-0 right-4 sm:right-6 lg:right-8 w-[360px] xl:w-[400px] pointer-events-none z-10" data-id="element-182">
          <img src="https://cdn.magicpatterns.com/uploads/wbAgEfoQRZWHxqkDVncn6B/wearhaus_girl_speech_transparent.png" alt="Wear Haus Mascot" className="w-full h-auto block" style={{
          marginBottom: '-4px'
        }} data-id="element-183" />
        </div>

        <div className="relative min-h-[400px] py-8 lg:py-12 flex items-center" data-id="element-184">
          {/* Content - Full width for H1 */}
          <div className="relative z-20 w-full" data-id="element-185">
            <h1 className="text-4xl lg:text-6xl font-extrabold text-white leading-tight mb-6 lg:pr-[420px] xl:pr-[460px]" data-id="element-186">
              Custom Apparel, Screen Printing & Promotional Products in
              LaGrange, Indiana
            </h1>

            <p className="text-lg text-white/95 mb-8 leading-relaxed max-w-2xl" data-id="element-187">
              Specializing in screen printing, embroidery, DTG, DTF, laser
              engraving, and custom promotional products for businesses,
              schools, teams, and events across Northeast Indiana.
            </p>

            <div className="flex flex-col sm:flex-row gap-4" data-id="element-188">
              <Button variant="primary" size="lg" rightIcon={<ArrowRight className="w-5 h-5" data-id="element-190" />} className="!bg-wh-pink !text-white hover:!bg-pink-600 !border-0" data-id="element-189">
                Get a Quote
              </Button>
              <Button variant="primary" size="lg" className="!bg-wh-yellow !text-gray-900 hover:!bg-yellow-400 !border-0" data-id="element-191">
                Shop Custom Products
              </Button>
            </div>

            <div className="mt-12 flex flex-wrap items-center gap-6 text-sm font-semibold text-white/90" data-id="element-192">
              <div className="flex items-center gap-2" data-id="element-193">
                <div className="w-2 h-2 rounded-full bg-white" data-id="element-194" />
                In-House Production
              </div>
              <div className="flex items-center gap-2" data-id="element-195">
                <div className="w-2 h-2 rounded-full bg-wh-yellow" data-id="element-196" />
                Fast Turnaround
              </div>
              <div className="flex items-center gap-2" data-id="element-197">
                <div className="w-2 h-2 rounded-full bg-wh-pink" data-id="element-198" />
                Local Indiana Business
              </div>
            </div>
          </div>

          {/* Mobile Mascot Image - Scaled down */}
          <div className="lg:hidden absolute bottom-0 right-0 w-48 sm:w-64 opacity-30 pointer-events-none" data-id="element-199">
            <img src="https://cdn.magicpatterns.com/uploads/wbAgEfoQRZWHxqkDVncn6B/wearhaus_girl_speech_transparent.png" alt="Wear Haus Mascot" className="w-full h-auto block" style={{
            marginBottom: '-4px'
          }} data-id="element-200" />
          </div>
        </div>
      </div>
    </section>;
}